import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ScreenService } from 'core/services';
import { ConsentRequestedPresenter } from './presenter';

export const ConsentRequested: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {ScreenService.getDocumentTitle(t('ui.pages.ConsentRequested.title'))}
        </title>
      </Helmet>
      <ConsentRequestedPresenter />
    </>
  );
};
